import { render, staticRenderFns } from "./supplierDetail.vue?vue&type=template&id=2054b1de&"
import script from "./supplierDetail.vue?vue&type=script&lang=js&"
export * from "./supplierDetail.vue?vue&type=script&lang=js&"
import style0 from "./supplierDetail.vue?vue&type=style&index=0&id=2054b1de&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2054b1de')) {
      api.createRecord('2054b1de', component.options)
    } else {
      api.reload('2054b1de', component.options)
    }
    module.hot.accept("./supplierDetail.vue?vue&type=template&id=2054b1de&", function () {
      api.rerender('2054b1de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/supplierDetail.vue"
export default component.exports